// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getDaysInYear as fn } from "../getDaysInYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getDaysInYearWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default getDaysInYearWithOptions;
